import React, { useState, useEffect } from "react";
import axios from "axios";

import { ItemListResponse } from "helpers/interfaces";

interface IUserGroupsContext {
    userGroups: IUserGroups[]
    isLoading: boolean

    setUserGroups: (v: IUserGroups[]) => void
    getUserGroups: () => void
    deleteUserGroup: (TypeId: string) => Promise<void>
}

export interface IUserGroups {
    code: string
    id: string
    description: string
}

export let UserGroupsContext = React.createContext<IUserGroupsContext>({} as IUserGroupsContext);

let { Provider } = UserGroupsContext;


let UserGroupProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {

    let [isLoading, setLoading] = useState(true);
    let [userGroups, setUserGroups] = useState<IUserGroups[]>([]);



    useEffect(() => {
        getUserGroups()
    }, [])


    let getUserGroups = async () => {
        try {
            setLoading(true);

            let response = await axios.get<ItemListResponse<IUserGroups>>('/api/UserGroup/GetUserGroups');
            setUserGroups(response.data.items);

        } catch (error) { }
        finally {
            setLoading(false);
        }
    }

    let deleteUserGroup = async (typeId: string) => {
        if (window.confirm("Are you sure that you want to remove this User Group?")) {
            try {
                await axios.delete(`/api/UserGroup/DeleteUserGroup/${typeId}`);
                setUserGroups(userGroups.filter(type => type.code !== typeId));
                getUserGroups()

            } catch (err) { }
        }
    }

    return (
        <Provider value={{
            userGroups,
            isLoading,

            setUserGroups,
            getUserGroups,
            deleteUserGroup
        }}>
            {children}
        </Provider>
    );
};

export default UserGroupProvider